
import React from 'react';
import { FileText, Upload, History, Globe, HelpCircle, Settings } from 'lucide-react';
import type { View } from '../types';

interface SidebarProps {
  currentView: View;
  setCurrentView: (view: View) => void;
  sidebarOpen: boolean;
  isAdmin: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, setCurrentView, sidebarOpen, isAdmin }) => {
  const navItems = [
    { view: 'dashboard', icon: FileText, label: 'Dashboard', restricted: false },
    { view: 'upload', icon: Upload, label: 'New Declaration', restricted: false },
    { view: 'history', icon: History, label: 'History', restricted: false },
    { view: 'settings', icon: Settings, label: 'Settings', restricted: true },
  ] as const;

  const resourceItems = [
    { label: 'ASYCUDA Guide', icon: Globe },
    { label: 'Support', icon: HelpCircle },
  ];

  return (
    <aside className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 fixed lg:static inset-y-0 left-0 w-64 bg-gray-800 border-r border-gray-700 transition-transform duration-300 ease-in-out z-40 mt-[81px] lg:mt-0`}>
      <nav className="p-4 space-y-2">
        {navItems.map((item) => {
          if (item.restricted && !isAdmin) return null;
          
          return (
            <button
              key={item.view}
              onClick={() => setCurrentView(item.view)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                currentView === item.view
                  ? 'bg-gradient-to-r from-teal-600 to-blue-700 text-white shadow-lg'
                  : 'hover:bg-gray-700 text-gray-300'
              }`}
            >
              <item.icon size={20} />
              <span className="font-medium">{item.label}</span>
            </button>
          );
        })}

        <div className="pt-4 mt-4 border-t border-gray-600">
          <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Resources</p>
          {resourceItems.map((item, index) => (
            <button key={index} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-gray-700 text-gray-300 transition-all">
              <item.icon size={20} />
              <span className="font-medium">{item.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
